import React from 'react';
import { Button } from 'common-ui';
import { handleMiniCartClickEvents, handleRedirectionClick } from '../../../../utils/cart/miniCartUtils';
import { pluralize } from '../../../../utils';

type ViewCartProps = {
  totalLineItem: number;
  redirectLink: string;
  onClose: () => void;
  isUK: boolean;
};

const ViewCart = ({ totalLineItem, redirectLink, onClose, isUK }: ViewCartProps) => {
  const viewCartText = isUK ? 'basket' : 'cart';
  const itemLabel = pluralize('ITEM', totalLineItem);

  return (
    <Button
      kind="secondary"
      onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
        handleRedirectionClick(e, redirectLink, onClose);
        handleMiniCartClickEvents('viewMiniCartClick');
      }}
      className="view-basket"
    >
      VIEW {viewCartText.toUpperCase()} ({totalLineItem} {itemLabel.toUpperCase()})
    </Button>
  );
};

export default ViewCart;
